<div class="w-100 h-100 overlay d-flex flex-column">
  <div class="d-flex flex-fill top-section w-100">
    <div class="w-50 left-top"></div>
    <div class="w-50 right-top"></div>
  </div>

  <div class="middle-section text-center">
    <div class="w-100"><img class="grab" loading="lazy" data-src="/assets/images/sip/grab.png" /></div>
    <div class="w-100"><img class="grab-text" loading="lazy" data-src="/assets/images/sip/tap-and-hold.png" /></div>
  </div>

  <div class="d-flex bottom-section">
    <div class="w-50 h-100 left-bottom">
      <img class="tap-left-new" loading="lazy" data-src="/assets/images/sip/tap_left.png" />
    </div>
    <div class="w-50 h-100 right-bottom">
      <img class="tap-right-new" loading="lazy" data-src="assets/images/sip/tap_right.png" />
    </div>
  </div>
</div>
